import { AxiosProgressEvent, AxiosResponse } from 'axios';

import { client } from '../client';

import { termEndPoints } from './endpoints';
import {
  ProductBoundariesRequest,
  ProductBoundariesResponse,
  ProductFeaturesRequest,
  ProductFeaturesResponse,
  TermAddOnsRequest,
  TermAddOnsResponse,
  TermCoverSuggestionRequest,
  TermCoverSuggestionResponse,
  TermEstimateRequest,
  TermEstimateResponse,
  TermPayOptionsRequest,
  TermPayOptionsResponse,
  TermPincodeVerificationRequest,
  TermPincodeVerificationResponse,
  TermPremiumRequest,
  TermPremiumResponse,
  TermQuoteFinalizeRequest,
  TermQuoteFinalizeResponse
} from './types';

export const termQuoteAPIs = {
  getProductBoundaries: (
    payload: ProductBoundariesRequest
  ): Promise<AxiosResponse<ProductBoundariesResponse, ProductBoundariesRequest>> => {
    return client.post<ProductBoundariesResponse, ProductBoundariesRequest>(
      termEndPoints.boundaries,
      payload
    );
  },
  getTermSuggestions: (
    payload: TermCoverSuggestionRequest
  ): Promise<
    AxiosResponse<TermCoverSuggestionResponse, TermCoverSuggestionRequest>
  > => {
    return client.post<TermCoverSuggestionResponse, TermCoverSuggestionRequest>(
      termEndPoints.suggestion,
      payload
    );
  },
  getTermEstimate: (
    payload: TermEstimateRequest
  ): Promise<AxiosResponse<TermEstimateResponse, TermEstimateRequest>> => {
    return client.post<TermEstimateResponse, TermEstimateRequest>(
      termEndPoints.estimate,
      payload
    );
  },
  getTermPayOptions: (
    payload: TermPayOptionsRequest
  ): Promise<AxiosResponse<TermPayOptionsResponse, TermPayOptionsRequest>> => {
    return client.post<TermPayOptionsResponse, TermPayOptionsRequest>(
      termEndPoints.payoptions,
      payload
    );
  },
  getAddOns: (
    payload: TermAddOnsRequest
  ): Promise<AxiosResponse<TermAddOnsResponse, TermAddOnsRequest>> => {
    return client.post<TermAddOnsResponse, TermAddOnsRequest>(
      termEndPoints.addons,
      payload
    );
  },
  getProductFeatures: (
    payload: ProductFeaturesRequest
  ): Promise<AxiosResponse<ProductFeaturesResponse, ProductFeaturesRequest>> => {
    return client.post<ProductFeaturesResponse, ProductFeaturesRequest>(
      termEndPoints.features,
      payload
    );
  },
  getTermPremium: (
    payload: TermPremiumRequest,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
    onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void
  ): Promise<AxiosResponse<TermPremiumResponse, TermPremiumRequest>> => {
    return client.post<TermPremiumResponse, TermPremiumRequest>(
      termEndPoints.premium,
      payload,
      {
        onUploadProgress,
        onDownloadProgress
      }
    );
  },
  verifyPincode: (
    payload: TermPincodeVerificationRequest
  ): Promise<
    AxiosResponse<TermPincodeVerificationResponse, TermPincodeVerificationRequest>
  > => {
    return client.post<
      TermPincodeVerificationResponse,
      TermPincodeVerificationRequest
    >(termEndPoints.verifyPincode, payload);
  },
  finalizeTermQuote: (
    payload: TermQuoteFinalizeRequest
  ): Promise<AxiosResponse<TermQuoteFinalizeResponse, TermQuoteFinalizeRequest>> => {
    return client.post<TermQuoteFinalizeResponse, TermQuoteFinalizeRequest>(
      termEndPoints.finalize,
      payload
    );
  }
};
